(function () {
    'use strict';

    const caseSliders = document.querySelectorAll('.org-case-block');
    let swiperModal;

    function checkArrows(swiper) {
        if (swiper.isBeginning && swiper.isEnd) {
            $(swiper.navigation.prevEl).addClass('hide-prevnext');
            $(swiper.navigation.nextEl).addClass('hide-prevnext');
        } else {
            $(swiper.navigation.prevEl).removeClass('hide-prevnext');
            $(swiper.navigation.nextEl).removeClass('hide-prevnext');
        }
    }

    function openModal(index, targetModal, swiperContainer) {
        targetModal.classList.add('grid');
        targetModal.classList.remove('hidden');
        document.body.style.overflow = "hidden";

        if (!swiperModal) {
            swiperModal = new Swiper(swiperContainer, {
                a11y: true,
                keyboard: {
                    enabled: true,
                },
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 32,
                navigation: {
                    nextEl: targetModal.querySelector('.swiper-next'),
                    prevEl: targetModal.querySelector('.swiper-prev'),
                },
                pagination: {
                    el: targetModal.querySelector('.swiper-pagination'),
                    clickable: true,
                    type: 'bullets',
                },
                on: {
                    init: function () {
                        toggleNavigation(targetModal);
                    },
                    afterInit: function () {
                        checkArrows(this);
                    },
                    resize: function () {
                        checkArrows(this);
                    },
                },
            });
        }

        swiperModal.slideTo(index, false);
    }

    function toggleNavigation(targetModal) {
        if (targetModal.querySelectorAll(".swiper-slide").length <= 1) {
            targetModal.querySelector('.swiper-next').style.display = 'none';
            targetModal.querySelector('.swiper-prev').style.display = 'none';
        } else {
            targetModal.querySelector('.swiper-next').style.display = '';
            targetModal.querySelector('.swiper-prev').style.display = '';
        }
    }

    function closeModal(targetModal) {
        targetModal.classList.add('hidden');
        targetModal.classList.remove('grid');
        document.body.style.overflow = "";

        if (swiperModal) {
            swiperModal.destroy(true, true);
            swiperModal = null;
        }
    }

    caseSliders.forEach((caseSlider) => {
        const caseItems = caseSlider.querySelectorAll(
            '.org-case-block-list-item'
        );
        const swiperContainer = caseSlider.querySelector('.swiper');

        caseItems.forEach((caseItem, index) => {
            caseItem.addEventListener('click', (e) => {
                e.preventDefault();
                const targetModal = caseItem
                    .closest('section')
                    .querySelector('[data-modal]');

                openModal(index, targetModal, swiperContainer);
            });
        });
    });

    const modalCloseButtons = document.querySelectorAll('[data-close-modal]');
    modalCloseButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const targetModal = button.closest('div.modal');
            closeModal(targetModal);
        });
    });
})();
